import React from 'react';
import { theme } from '@fiverr-private/theme';
import { SYSTEM_ICON_SIZES } from '../../constants';
import type { SystemIconType } from '../../types';

const UserForwardIcon = ({ size = 'sm', color = 'currentColor' }: SystemIconType) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={SYSTEM_ICON_SIZES[size]}
    height={SYSTEM_ICON_SIZES[size]}
    fill={theme.colors[color]}
    viewBox="0 0 20 20"
  >
    <path
      stroke="#74767E"
      strokeWidth={0.3}
      d="M9.82 10.559a5 5 0 0 0 .347 0 7.74 7.74 0 0 1 3.591.97.703.703 0 0 0 .684-1.23 9 9 0 0 0-1.58-.69 4.78 4.78 0 0 0 1.92-3.828A4.787 4.787 0 0 0 10 1a4.787 4.787 0 0 0-4.781 4.781c0 1.565.755 2.957 1.92 3.83a9.14 9.14 0 0 0-6.093 6.813A2.136 2.136 0 0 0 3.134 19h5.495a.703.703 0 0 0 0-1.406H3.134a.72.72 0 0 1-.563-.268.74.74 0 0 1-.149-.616c.73-3.507 3.826-6.068 7.399-6.151ZM6.626 5.78A3.38 3.38 0 0 1 10 2.406a3.38 3.38 0 0 1 3.375 3.375 3.38 3.38 0 0 1-3.208 3.371 9 9 0 0 0-.332 0 3.38 3.38 0 0 1-3.21-3.37ZM19 14.072c0 .47-.183.911-.517 1.243l-1.308 1.3a.7.7 0 0 1-.994-.002.703.703 0 0 1 .003-.994l.876-.872h-3.984c-.785 0-1.424.639-1.424 1.423 0 .785.631 1.424 1.407 1.424a.703.703 0 0 1 0 1.406 2.79 2.79 0 0 1-1.995-.831 2.82 2.82 0 0 1-.818-1.999c0-1.56 1.27-2.83 2.83-2.83h3.92l-.81-.8a.703.703 0 1 1 .988-1l1.306 1.29c.335.332.52.772.52 1.242Z"
    />
  </svg>
);
UserForwardIcon.id = 'UserForwardIcon';
UserForwardIcon.displayName = 'UserForwardIcon';
export default UserForwardIcon;
